import React, { useState, useContext, cloneElement, useMemo } from "react";
import "../styles.css";
import Context from "../Context";
import Localbase from "localbase";

let db = new Localbase("db");

const CardUploadImage = ({ htmlFor }) => {
  const { showIcons } = useContext(Context);

  const [imgPreview, setImgPreview] = useState();

  const [error, setError] = useState(false);

  // Get image from indexeddb to state imgPreview with lib Localbase
  db
  .collection("CardsPhotos")
  .doc(htmlFor)
  .get()
  .then((document) => {
    
    document && setImgPreview(document.image);
  });


  const handleImageChange = (e) => {
    setError(false);
    const selected = e.target.files[0];
    /* console.log("e.target.files", e.target.files); */
    const ALLOWED_TYPES = ["image/png", "image/jpeg", "image/jpg"];

    if (selected && ALLOWED_TYPES.includes(selected.type)) {
      let reader = new FileReader();

      reader.onloadend = () => {
        setImgPreview(reader.result);
        // create a collection ( 'CardsPhotos' ) and  document ( htmlFor ) with Localbase
        db.collection("CardsPhotos").add(
          {
            image: reader.result,
          },
          htmlFor
        );
      };

      reader.readAsDataURL(selected);
    } else {
      setError(true);
    }

    
  };

  /* const handleSaveImage = () => {
    localStorage.setItem(htmlFor, JSON.stringify(imgPreview));
    alert("elemento guardado");
  }; */
  

  const handleDeleteImage = () => {
    db.collection("CardsPhotos").doc(htmlFor).delete();

    setTimeout(() => {
      setImgPreview(null);
    }, 100);
  };

  return (
    <div className="container">
      {error && <p className="errorMsg">File not supported</p>}
      <div
        className="imgPreview"
        style={{
          background: imgPreview
            ? `url("${imgPreview}") no-repeat center/cover`
            : "#131313",
        }}
      >
        {!imgPreview && (
          <>
            <p>Añade una fotografía</p>
            <label htmlFor={htmlFor} className="customFileUpload">
              CLICK para escoger el archivo
            </label>
            <input type="file" id={htmlFor} onChange={handleImageChange} />
            <span>(jpg, jpeg o png)</span>
          </>
        )}
      </div>

      {showIcons && (
        <div className="icons-card-canvas mb-5">
          <img
            className="icon-trash-canvas"
            src="/assets/images/trash.png"
            alt="icon-trash"
            onClick={handleDeleteImage}
          />

          {/*  <img
            className="icon-trash-canvas"
            src="/assets/images/icon-download.png"
            alt="icon-download"
            onClick={handleSaveImage}
          /> */}
        </div>
      )}
    </div>
  );
};

export default CardUploadImage;
